import React, { useState } from 'react';
import { 
  Box, 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  Drawer, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText,
  Divider,
  IconButton
} from '@mui/material';
import {
  Menu as MenuIcon,
  Dashboard as DashboardIcon,
  Devices as DevicesIcon,
  Factory as FactoryIcon,
  ShoppingCart as ShoppingCartIcon,
  LocalShipping as ShippingIcon,
  AccountCircle as AccountIcon
} from '@mui/icons-material';
import { useAuth } from './contexts/AuthContext';
import ProductionManagementPage from './pages/ProductionManagementPage';
import DeviceManagementPage from './pages/DeviceManagementPage';

const drawerWidth = 240;

function App() {
  const { user, login, logout, isAuthenticated } = useAuth();
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleLogin = () => {
    login('demo@example.com', 'password');
  };

  const menuItems = [
    { id: 'dashboard', label: '儀表板', icon: <DashboardIcon /> },
    { id: 'production', label: '產線管理', icon: <FactoryIcon /> },
    { id: 'devices', label: '裝置管理', icon: <DevicesIcon /> },
    { id: 'orders', label: '訂單管理', icon: <ShoppingCartIcon /> },
    { id: 'shipping', label: '出貨管理', icon: <ShippingIcon /> },
  ];

  const renderPage = () => {
    switch (currentPage) {
      case 'production':
        return <ProductionManagementPage />;
      case 'devices':
        return <DeviceManagementPage />;
      case 'orders':
        return (
          <Box sx={{ p: 3 }}>
            <Typography variant="h4">訂單管理</Typography>
            <Typography>訂單管理功能開發中...</Typography>
          </Box>
        );
      case 'shipping':
        return (
          <Box sx={{ p: 3 }}>
            <Typography variant="h4">出貨管理</Typography>
            <Typography>出貨管理功能開發中...</Typography>
          </Box>
        );
      default:
        return (
          <Box sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom>
              儀表板
            </Typography>
            <Typography variant="h6" color="text.secondary" paragraph>
              React 前端已成功整合到 ASP.NET Core 應用程式中
            </Typography>
            <Typography variant="body1" paragraph>
              {isAuthenticated 
                ? `歡迎回來，${user?.name}！您已成功登入系統。`
                : '這是一個簡化版本的 React 應用程式，用於測試整合是否成功。'
              }
            </Typography>
          </Box>
        );
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => setDrawerOpen(!drawerOpen)}
            edge="start"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Helios 管理系統
          </Typography>
          {isAuthenticated ? (
            <Button color="inherit" onClick={logout} startIcon={<AccountIcon />}>
              登出 ({user?.name})
            </Button>
          ) : (
            <Button color="inherit" onClick={handleLogin}>
              登入
            </Button>
          )}
        </Toolbar>
      </AppBar>

      <Drawer
        variant="temporary"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto' }}>
          <List>
            {menuItems.map((item) => (
              <ListItem
                button
                key={item.id}
                onClick={() => {
                  setCurrentPage(item.id);
                  setDrawerOpen(false);
                }}
                selected={currentPage === item.id}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.label} />
              </ListItem>
            ))}
          </List>
          <Divider />
        </Box>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 0 }}>
        <Toolbar />
        {renderPage()}
      </Box>
    </Box>
  );
}

export default App;